interface RoomsToolbarButtonProps {
  onClick: () => void;
}

/**
 * Header toolbar button that opens the Edit Rooms dialog. Visually mirrors the
 * Refresh Calendar button so the toolbar reads as a single row of equivalent
 * actions (matches prototype lines 365–368). The schedule home page is
 * responsible for gating this on the OrgAdmin+ role; the button itself is
 * presentation-only.
 */
export function RoomsToolbarButton({ onClick }: RoomsToolbarButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="schedule-rooms-button"
      aria-label="Edit rooms"
      className="bg-surface-2 text-text-soft rounded-md px-3 py-1.5 font-medium text-[13px] cursor-pointer flex items-center gap-1.5 hover:bg-surface-2/80"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 21V9" />
      </svg>
      Rooms
    </button>
  );
}
